import type { NextJSProjectRouter } from "replo-publisher/src/trpc/routers/nextJSProject";

import { getNamespacedQueryClient } from "@v2/trpc/trpc";

import { createTrpcRouterConfig } from "../config";

const {
  router: nextJSProjectRouter,
  client: nextJSProjectClient,
  utils: nextJSProjectUtils,
  options: nextJSProjectOptions,
} = createTrpcRouterConfig<NextJSProjectRouter>({
  path: "nextJSProject",
  queryClient: getNamespacedQueryClient("nextJSProject"),
});

export {
  nextJSProjectClient,
  nextJSProjectRouter,
  nextJSProjectUtils,
  nextJSProjectOptions,
};
